export const invalidRoutes = [
  '/accounting',
  '/assets/groups',
  '/banks',
  '/banks/inquiries',
  '/banks/normativity',
  '/banks/normativity/authorization',
  '/settings',
  '/settings/templates',
  '/settings/access',
  '/debt_collections',
  '/condusef',
  '/pld',
  '/pld/catalogs',
  '/pld/analysis',
  '/pld/reports',
  '/logs',
  '/_demo',
];
